// @ts-ignore
import { ReactComponent as Logo } from "../assets/images/logo.svg";
import { OutboundLink } from "./Map";

export const Header = ({ referrer }) => (
  <div className="nav-container">
    <div className="nav-logo">
      <OutboundLink to="https://thecity.nyc/" referrer={referrer}>
        <span aria-label="THE CITY">
          <Logo />
        </span>
      </OutboundLink>
    </div>
    <div className="nav-title"></div>
    <div className="nav-links">
      <OutboundLink to="https://donorbox.org/nycdonate" referrer={referrer}>
        Donate
      </OutboundLink>
    </div>
  </div>
);
